/**
 * These categories are groups of recipes based on
 *  - the healthiest
 *  - special diets
 *  - the most popular
 *  - time of the days
 *  - promoting fruits
 *
 * 7 meals of the day https://www.englishclub.com/ref/esl/Power_of_7/7_Meals_of_the_Day_2946.php
 */

import Category from './Category'

const categories: Category[] = [
  { name: 'vegan', image: '586-vege-outline-edited' },
  { name: 'gluten-free', image: '597-gluten-free-outline-edited' },
  { name: 'fish', image: '522-fish-outline-edited' },
  // { name: 'cocktail', image: 'kplycyjp' },
  { name: 'sushi', image: '621-shushi-outline-edited' },
  { name: 'pie', image: '573-apple-pie-outline-edited' },
  { name: 'ice cream', image: '549-ice-cream-scoops-outline-edited' },
  { name: 'rice', image: '2236-risotto-rice-dish-outline-edited' },
  { name: 'soup', image: '2372-bowl-of-soup-outline-edited' },
  { name: 'dessert', image: '548-birthday-cake-candle-outline-edited' },
  { name: 'meat', image: '550-meat-outline-edited' },
  { name: 'seafood', image: '568-shrimp-outline-edited' },
  { name: 'juice', image: '600-juice-outline-edited' },
  { name: 'pasta', image: '603-plate-pasta-outline-edited' },
  { name: 'cheese', image: '556-cheese-outline-edited' },
  { name: 'taco', image: '566-taco-outline-edited' },
  { name: 'candy', image: '2230-candy-cane-outline-edited' },
  { name: 'egg', image: '619-fried-egg-outline-edited' },
  { name: 'pastry', image: '574-croissant-outline-edited' },
  { name: 'breakfast', image: '2348-pancakes-outline-edited' },
  { name: 'bread', image: '546-bread-outline-edited' },
  { name: 'chocolate', image: '517-chocolate-bar-outline-edited' },
  { name: 'fritters', image: '2333-fritters-outline-edited' },
  { name: 'coffee', image: '239-coffee-outline-edited' },
  { name: 'biscuit', image: '2335-shortbread-outline-edited' },
  { name: 'donut', image: '564-donut-outline-edited' },
  { name: 'fries', image: '567-french-fries-chips-outline-edited' },
  { name: 'strawberries', image: '578-strawberry-outline-edited' },
  { name: 'grape', image: '581-grape-outline-edited' },
  { name: 'banana', image: '577-banana-outline-edited' },
  { name: 'pizza', image: '13-pizza-outline-edited' },
  { name: 'apple', image: '543-apple-outline-edited' },
  { name: 'baby', image: '1512-mom-feeding-baby-outline-edited' },
  { name: 'pregnancy diet', image: '1270-fetus-outline-edited' },
  { name: 'pineapple', image: '1843-pineapple-outline-edited' },
  { name: 'drink', image: '600-juice-outline-edited' },
  { name: 'spicy', image: '587-one-chili-pepper-hot-outline-edited' },
  { name: 'honey', image: '557-honey-outline-edited' },
  { name: 'appetizer', image: '627-brezel-outline-edited' },
  { name: 'snack', image: '565-toast-sandwich-outline-edited' },
  // { name: 'baking', image: '675-male-cook-outline-edited' },
  { name: 'avocado', image: '594-avocado-outline-edited' },
  { name: 'alcohol', image: '519-glass-pint-beer-outline-edited' },
  { name: 'waffle', image: '2375-waffle-outline-edited' },
  { name: 'sausage', image: '563-sausage-outline-edited' },
  // { name: 'cookie', image: 'jwdvjivv' }, // not common
  { name: 'nuts', image: '2371-nuts-outline-edited' },
]

export default categories
